import TVdxbApplicationInviteUserUpload from './index.vue';

TVdxbApplicationInviteUserUpload.install = app => {
  app.component(TVdxbApplicationInviteUserUpload.name, TVdxbApplicationInviteUserUpload);
};

export default TVdxbApplicationInviteUserUpload;
